<ng-container *ngIf="!skipIndexes.includes(index)">
  <ng-container *ngIf="isFullDate; else textComponent">
    <mat-form-field class="disabled" appearance="fill">
      <mat-label>{{ '+GENERAL.DATEPICKER.DAY_PICKER' | translate }}</mat-label>
      <input
        data-at-day-datepicker
        matInput
        readonly
        [attr.disabled]="true"
        [matDatepicker]="datepicker"
        [formControl]="datepickerDate"
      />
      <mat-datepicker-toggle matSuffix [for]="datepicker" [disabled]="true"></mat-datepicker-toggle>
      <mat-datepicker #datepicker panelClass="day-datepicker" [disabled]="true"></mat-datepicker>
    </mat-form-field>
  </ng-container>
  <ng-template #textComponent>
    <ng-container *ngFor="let index of skippedIndexes">
      <app-vdd-text-readonly
        [label]="matchedValues[index]?.translationid | translate"
        [value]="matchedValues[index]?.value"
        [isDescription]="false"
      >
      </app-vdd-text-readonly>
    </ng-container>
  </ng-template>
</ng-container>
